<template>
    <div>
        <b-form-group
            id="provider-group"
            label="Aanbieder"
            label-for="provider-input">
            <design-2021-apprentice-multiselect-component
                class="apprentice-select with-border provider-select"
                id="provider-input"
                v-model="provider"
                label="label"
                :multiple-select="false"
                :options="providers"
                track-by="name"
                @input="resetFields"
                :allow-empty="false">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>
        <div v-if="provider.name === 'magister'">
            <b-form-group
                id="input-group-brin"
                label="Brin"
                label-for="input-brin">
                <b-form-input
                    id="input-brin"
                    v-model="brin"></b-form-input>
            </b-form-group>
            <b-form-group
                id="input-group-brin"
                label="Brin-toevoeging"
                label-for="input-brin">
                <b-form-input
                    id="input-brin"
                    v-model="brinAddition"></b-form-input>
            </b-form-group>
        </div>
        <div v-else-if="provider.name === 'somtoday-connect'">
            <b-form-group
                id="organization_external_id"
                label="Externe organisatie-ID"
                label-for="input-organization-external-id">
                <b-form-input
                    id="input-organization-external-id"
                    v-model="organizationExternalId"></b-form-input>
                <b-form-text>De ID waarmee de aanbieder de organisatie identificeert.</b-form-text>
            </b-form-group>
        </div>

        <b-form-group
            id="location_external_id"
            label="Externe locatie-ID"
            label-for="input-location-external-id">
            <b-form-input
                id="input-location-external-id"
                v-model="locationExternalId"></b-form-input>
            <b-form-text>De ID waarmee de aanbieder de locatie identificeert.</b-form-text>
        </b-form-group>
        <b-button
            class="col-4 offset-8 btn btn-primary"
            variant="primary"
            @click="submit"
            >Opslaan
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-school-las-location-edit-component',
    props: {
        lasLocationIn: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            providers: [
                {
                    name: 'somtoday-connect',
                    label: 'SomToday Connect',
                },
                {
                    name: 'magister',
                    label: 'Magister',
                },
            ],
            provider: {
                name: this.lasLocationIn.provider,
            },
            brin: this.lasLocationIn.brin,
            brinAddition: this.lasLocationIn.brin_addition,
            organizationExternalId: this.lasLocationIn.organization_external_id,
            locationExternalId: this.lasLocationIn.location_external_id,
            errors: null, //todo add errors
        };
    },
    methods: {
        submit() {
            this.alert.saving();

            let data = {
                provider: this.provider.name,
                brin: this.brin,
                brin_addition: this.brinAddition,
                location_external_id: this.locationExternalId,
                organization_external_id: this.organizationExternalId,
            };

            this.axios.post(this.routes.updateLasLocation(), data).then(
                (response) => {
                    this.$emit('lasLocationUpdated', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        resetFields() {
            if (this.provider.name === 'magister') {
                this.organizationExternalId = null;
            } else if (this.provider.name === 'somtoday-connect') {
                this.brin = null;
                this.brin_addition = null;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.form-group {
    margin-bottom: 1.5rem;

    .form-control {
        margin-bottom: 0;
    }
}
</style>
